import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/avatar/avatar.module.css
var css_248z = ".avatar-module_root__BdqPE {\n    &[data-action='true'] {\n        cursor: pointer;\n    }\n}\n";
var avatar_module_default = { "root": "avatar-module_root__BdqPE" };
style_inject_es_default(css_248z);

//#endregion
export { avatar_module_default as default };